import "./consent.scss";

export const Consent = ({ text }: { text: JSX.Element | string }) => {
  return (
    <div className="consent">
      <p className="consent--text">{text}</p>
    </div>
  );
};
